/** CO Points per tracked level: withdraw within 3 months or redistribute in ₹150 AFP slots. Primary L6–L15; child AFP L1–L15. */

import { AUTO_FILL_MAX_LEVEL, getLevelAmount } from "./autoFillProgramConfig";

/** Primary (root) AFP — forfeiture tracking starts at L6. */
export const AUTO_FILL_FORFEITURE_LEVEL_MIN = 6;
/** Spawned child AFP — same 3-month rule from L1–L15. */
export const AUTO_FILL_CHILD_FORFEITURE_LEVEL_MIN = 1;
export const AUTO_FILL_FORFEITURE_LEVEL_MAX = Math.min(15, AUTO_FILL_MAX_LEVEL);
export const AUTO_FILL_LEVEL_FORFEITURE_MONTHS = 3;

export function isChildAutoFillProgram(program) {
  return Boolean(program?.parentProgramId);
}

export function resolveForfeitureLevelMin(program) {
  return isChildAutoFillProgram(program)
    ? AUTO_FILL_CHILD_FORFEITURE_LEVEL_MIN
    : AUTO_FILL_FORFEITURE_LEVEL_MIN;
}
export const AUTO_FILL_LEVEL_FORFEITURE_CHUNK = 150;

export function addMonths(isoDate, months) {
  const d = new Date(isoDate);
  d.setMonth(d.getMonth() + months);
  return d;
}

/** User-facing deadline from level reached timestamp (includes time of day). */
export function levelForfeitureDeadlineDate(reachedAtIso) {
  if (!reachedAtIso) return null;
  return addMonths(reachedAtIso, AUTO_FILL_LEVEL_FORFEITURE_MONTHS);
}

export function formatAutoFillForfeitureDateTime(isoDate) {
  if (!isoDate) return "—";
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function levelForfeitureDue(reachedAtIso, now = new Date()) {
  if (!reachedAtIso) return false;
  const deadline = addMonths(reachedAtIso, AUTO_FILL_LEVEL_FORFEITURE_MONTHS);
  return now >= deadline;
}

export function levelUnwithdrawnAmount(levelState) {
  if (!levelState) return 0;
  const credited = Number(levelState.pointsCredited) || 0;
  const withdrawn = Number(levelState.pointsWithdrawn) || 0;
  const forfeited = Number(levelState.pointsForfeited) || 0;
  return Math.max(0, credited - withdrawn - forfeited);
}

export function getLevelForfeitureCap(level) {
  return getLevelAmount(Number(level));
}

export function redistributionSlotCount(unwithdrawnAmount) {
  const u = Number(unwithdrawnAmount) || 0;
  if (u < AUTO_FILL_LEVEL_FORFEITURE_CHUNK) return 0;
  return Math.floor(u / AUTO_FILL_LEVEL_FORFEITURE_CHUNK);
}

export function forfeitureLevelsInRange(currentProgramLevel, program = null) {
  const minL = resolveForfeitureLevelMin(program || {});
  const maxL = Math.min(
    Number(currentProgramLevel) || 1,
    AUTO_FILL_FORFEITURE_LEVEL_MAX
  );
  const levels = [];
  for (let L = minL; L <= maxL; L += 1) {
    levels.push(L);
  }
  return levels;
}
